<template>
  <button class="btn btn-primary w-100" type="button" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{ t.process_loading }}
  </button>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {t: this.$root.t}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue